import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { normalizeAiMarkdownForDisplay } from "@/lib/aiMarkdown";

export function AiMessageMarkdown({ content }: { content: string }) {
  return (
    <div
      className="w-full overflow-x-hidden max-w-full ai-message-content"
      style={{
        width: "100%",
        maxWidth: "100%",
        WebkitFontSmoothing: "antialiased",
        MozOsxFontSmoothing: "grayscale",
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "SF Pro Text", "SF Pro Display", system-ui, sans-serif',
        // iOS-specific: avoid text autoscaling surprises
        WebkitTextSizeAdjust: "100%",
        textSizeAdjust: "100%",
      }}
    >
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          p: ({ children, ...props }: any) => {
            const text = String(children || "").trim();
            if (!text) return null;
            return (
              <p className="break-words" {...props}>
                {children}
              </p>
            );
          },
          ul: (props: any) => <ul className="break-words" {...props} />,
          ol: (props: any) => <ol className="break-words" {...props} />,
          li: (props: any) => <li className="break-words" {...props} />,
          code: ({ className, children, ...props }: any) => {
            const text = String(children || "");
            const isFenced = typeof className === "string" && /language-/.test(className);

            if (isFenced) {
              const fenced = text.trim();
              // Hide plan/recipe JSON blocks from chat display while keeping them in the message for parsing/import.
              if (
                /("type"\s*:\s*"(?:weekly_plan|single_workout|running_workout)"|"recipes"\s*:\s*\[)/i.test(
                  fenced,
                )
              ) {
                return null;
              }

              return (
                <pre className="overflow-x-auto max-w-full bg-muted p-4 rounded-lg my-2">
                  <code className={className} {...props}>
                    {children}
                  </code>
                </pre>
              );
            }

            return (
              <code className={`${className} break-words bg-muted px-1 py-0.5 rounded`} {...props}>
                {children}
              </code>
            );
          },
          table: (props: any) => (
            <div className="overflow-x-auto max-w-full my-2">
              <table className="min-w-full border-collapse" {...props} />
            </div>
          ),
        }}
      >
        {normalizeAiMarkdownForDisplay(content)}
      </ReactMarkdown>
    </div>
  );
}
